import { render } from "./Button.vue?vue&type=template&id=d508eedc"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=d508eedc&lang=postcss"

import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__